import * as tslib_1 from "tslib";
import { defer } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "./request.service";
export class PhotoCollectionService {
    constructor(requestService) {
        this.requestService = requestService;
    }
    saveDocument(siteId, document) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let data = {
                title: document.title,
                description: document.description,
                date: document.date
            };
            if (document.id) {
                yield this.requestService.patch('photoCollection/update-planting-site-document', Object.assign({ documentId: document.id }, data));
                return document.id;
            }
            else {
                let result = yield this.requestService.post('photoCollection/create-planting-site-document', Object.assign({ plantingSiteId: siteId }, data));
                return result.data;
            }
        });
    }
    deletDocument(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.delete('photoCollection/delete-planting-site-document/' + id);
            return result.data;
        });
    }
    uploadCollectionPhoto(file, collectionId, lat, lon) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let formData = new FormData();
            formData.append('photo', file, file.name);
            formData.append('photoCollectionId', collectionId);
            formData.append('lat', lat.toString());
            formData.append('lon', lon.toString());
            let result = yield this.requestService.post('photoCollection/add-photo-to-collection', formData);
            return result.data;
        });
    }
    setCollectionThumbnail(collectionId, photoId) {
        return this.requestService.patch(`photoCollection/set-thumbnail/${collectionId}?photoId=${photoId}`, null);
    }
    updatePhoto(photo) {
        return this.requestService.post('photoCollection/update-photo', { photoId: photo.id, lat: Number(photo.lat), lon: Number(photo.lon) });
    }
    deletePhoto(photoId, plantingSiteId) {
        return this.requestService.delete(`photoCollection/delete-photo/${photoId}?plantingSiteId=${plantingSiteId}`);
    }
    getAllTitles() {
        return defer(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.get('photoCollection/titles');
            return result.data;
        }));
    }
}
PhotoCollectionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PhotoCollectionService_Factory() { return new PhotoCollectionService(i0.ɵɵinject(i1.RequestService)); }, token: PhotoCollectionService, providedIn: "root" });
